// extracted by mini-css-extract-plugin
export var internalNoteEditor = "_ib-1";
export var quotedThread = "_ib-0";